export type TrustpilotFallbackVariant = 'micro' | 'inline' | 'panel'

interface TrustpilotTemplate {
  variant: TrustpilotFallbackVariant
  label: string
}

const DEFAULT_LABEL = 'Trustpilot reviews'

const TEMPLATES: Record<string, TrustpilotTemplate> = {
  '5419b732fbfb950b10de65e5': { variant: 'micro', label: 'Trustpilot star rating' }, // Micro Star
  '5419b6ffb0d04a076446a9af': { variant: 'inline', label: 'Trustpilot rating summary' }, // Micro Combo
  '5406e65db0d04a09e042d5fc': { variant: 'inline', label: 'Trustpilot rating summary' }, // Horizontal
  '53aa8807dec7e10d38f59f32': { variant: 'inline', label: 'Trustpilot rating summary' }, // Mini
  '5418052cfbfb950d88702476': { variant: 'inline', label: 'Trustpilot rating summary' }, // unlabelled 30px
  '53aa8912dec7e10d38f59f36': { variant: 'panel', label: 'Trustpilot review carousel' }, // Carousel
  '54ad5defc6454f065c28af8b': { variant: 'panel', label: 'Trustpilot review slider' }, // Slider
  '54197383fd9dceac42a68694': { variant: 'panel', label: DEFAULT_LABEL }, // Flex
  '5717796816f630043868e2e8': { variant: 'panel', label: 'Trustpilot product reviews' }, // Product Reviews SEO
}

function template(templateId?: string | null): TrustpilotTemplate | undefined {
  return templateId ? TEMPLATES[templateId.trim()] : undefined
}

export function trustpilotFallbackVariant(templateId?: string | null): TrustpilotFallbackVariant {
  return template(templateId)?.variant ?? 'inline'
}

/** Human-readable name for the widget a template renders, for accessible naming. */
export function trustpilotTemplateLabel(templateId?: string | null): string {
  return template(templateId)?.label ?? DEFAULT_LABEL
}

export function trustpilotEmbedHeight(html?: string | null): string | null {
  const raw = html && /data-style-height\s*=\s*["']([^"']+)["']/i.exec(html)?.[1]?.trim()
  if (!raw)
    return null
  return /^\d+(?:\.\d+)?(?:px|rem|em|%)$/i.test(raw) ? raw : null
}
